import { useEffect, useState } from "react";
import { getHubPulse } from "@/lib/api";
import { PulseTicker } from "./PulseTicker";
import { FlockField } from "./FlockField";

/* Apertura dell'Hub: lo stormo in movimento con l'odometro luminoso sovrapposto. */
export const HubPulse = () => {
  const [pulse, setPulse] = useState(null);
  useEffect(() => { getHubPulse(30).then(setPulse).catch(() => {}); }, []);
  if (!pulse?.trades?.length) return null;
  return (
    <section
      data-testid="hub-pulse"
      className="relative -mx-4 md:-mx-8 xl:-mx-12 -mt-6 h-[58vh] min-h-[440px] overflow-hidden"
    >
      <FlockField className="absolute inset-0 h-full w-full" />
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(9,9,11,0.62),rgba(9,9,11,0.15)_55%,transparent_75%)]" />
      <span aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-[hsl(var(--background))]" />
      <div className="relative z-10 flex h-full items-center justify-center px-4">
        <PulseTicker pulse={pulse} />
      </div>
    </section>
  );
};

export default HubPulse;
